export default "__VITE_ASSET__CRARCRk6__"